import { Dispatch, SetStateAction } from 'react'

interface TablePaginationProps {
  setCurrentPage: Dispatch<SetStateAction<number>>
  totalPages?: number
  currPage?: number
}

const TablePagination = ({
  totalPages = 1,
  currPage = 1,
  setCurrentPage,
}: TablePaginationProps) => {
  const hasNext = currPage < totalPages
  const hasPrev = currPage > 1

  const nextPage = () => {
    if (hasNext) {
      setCurrentPage((page) => page + 1)
    }
  }

  const prevPage = () => {
    if (hasPrev) {
      setCurrentPage((page) => page - 1)
    }
  }

  return (
    <div className="sticky bottom-0 pb-10 flex flex-col items-center bg-white">
      <div className="flex flex-col items-center gap-5 leading-4 text-[12px]">
        <div className="flex gap-5">
          <span
            className={`p-2.5 ${
              hasPrev ? 'font-bold cursor-pointer' : 'text-gray-500 cursor-not-allowed'
            }`}
            onClick={prevPage}
          >
            &lt; Previous
          </span>

          <span className="flex gap-[6px]">
            {[...Array(totalPages)].map((_, index) => {
              const page = index + 1
              const isActive = page === currPage
              return (
                <span
                  key={page}
                  onClick={() => setCurrentPage(page)}
                  className={`p-2.5 rounded cursor-pointer ${
                    isActive
                      ? 'bg-gray-800 text-gray-50'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  {page}
                </span>
              )
            })}
          </span>

          <span
            className={`p-2.5 ${
              hasNext ? 'font-bold cursor-pointer' : 'text-gray-500 cursor-not-allowed'
            }`}
            onClick={nextPage}
          >
            Next &gt;
          </span>
        </div>
        <div>
          Page {currPage} of {totalPages}
        </div>
      </div>
    </div>
  )
}

export default TablePagination
